export const REGISTRATION = "registration";
export const PASSPORT_COPY_ONE = "passport_copy_one";
export const PASSPORT_COPY_TWO = "passport_copy_two";
export const POLICE = "police";
export const AFFIDAVIT = "affidavit";
export const IMMIGRATION_LETTER = "immigration_letter";
export const VISA = "visa";
export const AGREEMENT = "agreement";
export const TICKET = "ticket";
export const COMPLAIN = "complain";
